import { ActionType } from '@/configuration/actions/action-type'

export enum ConditionStatusScrollState {
    Default = 1,
    OilAnalysis,
    AnalysisComments,
    Recommendations,
    VisualInspection,
    ComponentComments,
}

export const CONDITION_STATUS_SCROLL_STATE_ACTION_TYPE_MAP: Record<ActionType, ConditionStatusScrollState> = {
    [ActionType.OilAnalysisReportSubmitted]: ConditionStatusScrollState.OilAnalysis,
    [ActionType.OilAnalysisReportInvalidated]: ConditionStatusScrollState.OilAnalysis,
    [ActionType.OilAnalysisUndoReportInvalidation]: ConditionStatusScrollState.OilAnalysis,
    [ActionType.AnalysisCommentSubmitted]: ConditionStatusScrollState.AnalysisComments,
    [ActionType.AnalysisCommentEdited]: ConditionStatusScrollState.AnalysisComments,
    [ActionType.AnalysisCommentDeleted]: ConditionStatusScrollState.AnalysisComments,
    [ActionType.ConditionStatusManuallyOverridden]: ConditionStatusScrollState.OilAnalysis,
    [ActionType.ThresholdEdited]: ConditionStatusScrollState.OilAnalysis,
    [ActionType.RecommendationEdited]: ConditionStatusScrollState.Recommendations,
    [ActionType.RecommendationSubmitted]: ConditionStatusScrollState.Recommendations,
    [ActionType.VisualInspectionReportSubmitted]: ConditionStatusScrollState.VisualInspection,
    [ActionType.ComponentConditionStatusCritical]: ConditionStatusScrollState.Default,
    [ActionType.ChangeInComponentConditionStatus]: ConditionStatusScrollState.Default,
    [ActionType.LastSynced]: ConditionStatusScrollState.Default,
    [ActionType.MarkedAsNoAction]: ConditionStatusScrollState.Default,
    [ActionType.UnmarkedAsNoAction]: ConditionStatusScrollState.Default,
    [ActionType.ReportSubmitted]: ConditionStatusScrollState.Default,
    [ActionType.ReportInvalidated]: ConditionStatusScrollState.Default,
    [ActionType.UndoReportInvalidation]: ConditionStatusScrollState.Default,
    [ActionType.VisualAnalysisReportSubmitted]: ConditionStatusScrollState.Default,
    [ActionType.ActionOverdue]: ConditionStatusScrollState.Recommendations,
    [ActionType.MeasurementSetAsReference]: ConditionStatusScrollState.OilAnalysis,
} as const
